// Language configuration. Components consume these values to render
// the right text/fonts/mappings without hard-coding "Hebrew" or "Arabic".

import {
  hebrewLetters,
  finalForms as hebrewFinals,
  symbols as hebrewSymbols,
  commonAbbreviations as hebrewAbbreviations,
  convertToHebrew,
} from './hebrewMapping';

import {
  arabicLetters,
  arabicAdditionalForms,
  arabicSymbols,
  arabicAbbreviations,
  convertToArabic,
} from './arabicMapping';

import {
  chineseLetters,
  chineseAdditionalForms,
  symbols as chineseSymbols,
  chineseAbbreviations,
  convertToChinese,
} from './chineseMapping';

export const LANGUAGE_CONFIG = {
  hebrew: {
    id: 'hebrew',
    brand: 'Hebrew Inscriptions Software',
    appTitle: 'Monument Inscription Designer',
    subtitle: 'Hebrew Inscriptions for Jewish Monuments',
    proofTitle: 'MONUMENT HEBREW',
    invocation: 'בס״ד',
    invocationFont: 'font-hebrew',
    dir: 'rtl',
    fontClass: 'font-hebrew',
    fontFamily: 'Frank Ruhl Libre, serif',
    keyboardLabel: 'Hebrew Keyboard',
    finalsLabel: 'Final Forms',
    finalsHelper: 'Final forms appear at the end of words',
    autoConvertLabel: 'Auto-convert English → Hebrew',
    rtlLabel: 'Right-to-Left Hebrew',
    placeholder: 'Begin typing your inscription',
    letters: hebrewLetters,
    finals: hebrewFinals,
    symbols: hebrewSymbols,
    abbreviations: hebrewAbbreviations,
    convert: convertToHebrew,
    accessor: 'hebrew',
  },
  arabic: {
    id: 'arabic',
    brand: 'Arabic Inscriptions Software',
    appTitle: 'Monument Inscription Designer',
    subtitle: 'Arabic Inscriptions for Memorials',
    proofTitle: 'MONUMENT ARABIC',
    invocation: 'بسم الله',
    invocationFont: 'font-arabic',
    dir: 'rtl',
    fontClass: 'font-arabic',
    fontFamily: '"Noto Naskh Arabic", Amiri, serif',
    keyboardLabel: 'Arabic Keyboard',
    finalsLabel: 'Forms',
    finalsHelper: 'Additional forms used in Arabic text',
    autoConvertLabel: 'Auto-convert English → Arabic',
    rtlLabel: 'Right-to-Left Arabic',
    placeholder: 'Begin typing your inscription',
    letters: arabicLetters,
    finals: arabicAdditionalForms,
    symbols: arabicSymbols,
    abbreviations: arabicAbbreviations,
    convert: convertToArabic,
    accessor: 'arabic',
  },
  chinese: {
    id: 'chinese',
    brand: 'Chinese Inscriptions Software',
    appTitle: 'Monument Inscription Designer',
    subtitle: 'Chinese Inscriptions for Memorials',
    proofTitle: 'MONUMENT CHINESE',
    invocation: '永垂不朽',
    invocationFont: 'font-chinese',
    dir: 'ltr',
    fontClass: 'font-chinese',
    fontFamily: '"Noto Serif SC", "SimSun", serif',
    keyboardLabel: 'Chinese Keyboard',
    finalsLabel: 'Names',
    finalsHelper: 'Common given name characters',
    autoConvertLabel: 'Simplified / Traditional',
    rtlLabel: 'Left-to-Right',
    placeholder: 'Begin typing your inscription',
    letters: chineseLetters,
    finals: chineseAdditionalForms,
    symbols: chineseSymbols,
    abbreviations: chineseAbbreviations,
    convert: convertToChinese,
    accessor: 'simplified',
    useTraditional: false, // Toggle for Simplified/Traditional
  },
};

export const getLanguage = (id) =>
  LANGUAGE_CONFIG[id] || LANGUAGE_CONFIG.hebrew;
